import { RouterLink } from "@angular/router";

export const MENU_ITEMS = [
  {
    label: 'Impulses Inbox', command: () => {
      //MENU_ITEMS[1].routerLink = "";
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    },
    items: [
      { label: 'Overview', routerLink: 'impulses' },
      { label: 'Create Own', routerLink: 'impulses/own-impulse' }
    ]

  },
  {
    label: 'Package View', routerLink: "part-package", command: () => {
      //MENU_ITEMS[1].routerLink = "";
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    }
    // items: [
    //   {
    //     label: 'View Packages', routerLink: "part-package/list", command: () => {
    //       MENU_ITEMS[1].routerLink = "part-package/list";
    //     }
    //   },
    //   {
    //     label: 'Create Packages', routerLink: "part-package/create-package", command: () => {
    //       MENU_ITEMS[1].routerLink = "part-package/create-package";
    //     }
    //   },
    // ]
  },
  {
    label: 'Part View',
    //routerLink: 'part-view',
    command: () => {
      //MENU_ITEMS[1].routerLink = 'part-view';
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    },
    items: [
      { label: 'Part Overview', routerLink: 'part-view/overview' },
      { label: 'Part Valid Price', routerLink: 'part-view/part-valid-price' },
      { label: 'Part Demand', routerLink: 'part-view/part-demand' },
      { label: 'Assigned Part', routerLink: 'part-view/assigned-part-overview'}
    ]
  },
  {
    label: 'Price View',
    routerLink: 'price-view/price-overview',
    command: () => {
      //MENU_ITEMS[1].routerLink = 'part-view';
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    }
  },
  {
    label: 'Supplier View',
    //routerLink: 'part-view',
    command: () => {
      //MENU_ITEMS[1].routerLink = 'part-view';
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    },
    items: [
      { label: 'Supplier', routerLink: 'supplier-view/supplier-overview' },
      { label: 'Supplier Share', routerLink: 'supplier-view/supplier-share-overview' },
    ]
  },
  {
    label: 'Find Your Colleague', routerLink: 'find-your-colleague', command: () => {
      //MENU_ITEMS[1].routerLink = "";
      if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
        MENU_ITEMS[4].routerLink = "";
      }
    }
  }
];
